<!-- 
  详情页 - 合同订单
  props:
    id: 产品
  emit: 
    openDetail: 打开详情页
 -->
<template>
  <div class="supplier-tab">
    <ul class="supplierList">
      <li v-for="item in supplierArr">
        <div class="listLeft">
          <h3 @click="openDetail(item.id)">{{item.name}}</h3>
          <h5>
            <span>联系人：</span>
            <span>{{item.contactName || '--'}}</span>
          </h5>
          <h5>
            <span>联系方式：</span>
            <span>{{getPhone(item.phone)}}</span>
          </h5>
          <h5>
            <span>联系地址：</span>
            <span>{{item.address || '--'}}</span>
          </h5>
          <h5>
            <span>负责人：</span>
            <span>{{item.managerName || '--'}}</span>
          </h5>
        </div>
        <div class="listRight">
          <em class="BottomRound"></em>
          <em class="TopRound"></em>
          <h6 v-for="it in item.rates">
            <span>{{it.attrName}}：</span>
            <el-rate
              :value="it.value4Show | toNumber"
              :colors="it.value4Show | toColor"
              disabled>
            </el-rate>
            <span class="tag low" v-if="it.value4Show < 3">低</span>
            <span class="tag high" v-else-if="it.value4Show > 4">高</span>
            <span class="tag mid" v-else>中</span>   
          </h6>
        </div>
      </li>
    </ul>
    <div class="pagination-wrapper clearfix">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :page-sizes="[10, 20, 30, 40]"
        layout="total, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import * as api from 'src/api'
export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    }
  },
  data () {
    return {
      total: 0,
      pageSize: 3,
      currentPage: 1,
      supplierArr: []
    }
  },
  methods: {
    // 请求供应商数据
    getList () {
      let url = `/productStock/getSupplier.html`
      let params = {
        productId: this.id,
        page: this.currentPage,
        pageSize: this.pageSize
      }
      api.post(url, params, (data) => {
        this.total = data.pageHelper.rowsCount // 总条数
        this.supplierArr = data.result // 供应商数据
      })
    },

    // 电话与号码
    getPhone (arr) {
      let phoneArr = arr.map((it) => {
        return it.telNum
      })
      return phoneArr.join('/')
    },

    // 每页所显示的条数变更
    handleSizeChange (val) {
      this.pageSize = val
      this.getList()
    },

    // 当前分页变更
    handleCurrentChange (val) {
      this.currentPage = val
      this.getList()
    },

    // 打开详情
    openDetail (id) {
      this.$emit('openDetail', 'supplier', id)
    }
  },
  filters: {
    toNumber (str) {
      return Number(str)
    },
    toColor (str) {
      str = Number(str)
      if (str < 3) {
        return ['#78c06e', '#78c06e', '#78c06e']
      } else if (str > 4) {
        return ['#ff6161', '#ff6161', '#ff6161']
      } else {
        return ['#ff7c35', '#ff7c35', '#ff7c35']
      }
    }
  }
}

</script>
<style lang="less">
  .supplier-tab{
    .el-table{margin: 15px auto;}
    .el-rate {
      display: inline-block;
      vertical-align: top;
      padding-top: 2px;
      .el-rate__icon {
        font-size: 14px;
      }
    }
  }
</style>
<style lang="less" scoped>
  .supplier-tab{
    padding:0 15px;
    .supplierList {
      li{
        border:1px solid #ddd;
        padding:10px;
        display: flex;
        flex-wrap: wrap;
      }
      .listLeft{
        width:58%;
        border-right:1px dashed #ddd;
        padding-right: 10px;
        h3{color:#008cee;font-size:16px;padding-bottom:10px;cursor: pointer;}
        h5{
          padding-bottom: 5px;
          span:nth-of-type(2){
            width:80%;
            display:inline-table;
            line-height: 18px;
            vertical-align: text-top;
          }
        }
      }
      .listRight{
        padding-left:5%;
        position: relative;
        .tag {
          display: inline-block;
          margin-left: 20px;
          font-size: 12px;
          width: 20px;
          height: 20px;
          line-height: 20px;
          text-align: center;
          border-radius: 2px;
          color: #FFF;
          transform: scale(0.8);
          &.high{
            background-color: #ff6161;
          }
          &.mid{
            background-color: #ff7c35;
          }
          &.low{
            background-color: #78c06e;
          }
        }
      }
      .BottomRound{/*下半圆*/
        border: 1px solid #ddd;
        border-top: none;
        width: 20px;
        background: #ffffff;
        height: 10px;
        border-radius: 0px 0px 20px 20px;
        display: inline-block;
        position: absolute;
        top: -11px;
        left: -12px;
      }
      .TopRound{/*下半圆*/
        border: 1px solid #ddd;
        border-bottom: none;
        width: 20px;
        background: #ffffff;
        height: 10px;
        border-radius:20px 20px 0px 0px;
        display: inline-block;
        position: absolute;
        bottom: -11px;
        left: -12px;
      }
    }
    .pagination-wrapper{width:100%;padding-top: 20px;}
    .pagination-wrapper .el-pagination {float:right;}
  }
</style>


// WEBPACK FOOTER //
// supplier-tab.vue?2c16def8